import { isNotBlankValue } from '../objects/isBlankValue';
import { isNotEmpty } from '../objects/isEmpty';

/**
 * Filter out null, undefined, or any empty strings
 *
 * @param values
 * @returns
 */
export function filterBlank<T>(values: Array<T | undefined | null> | undefined | null): T[] {
	if (!values?.length) {
		return [];
	}

	return values.filter(isNotBlankValue);
}

/**
 * Filter out null, undefined, empty strings, empty arrays, or empty objects (evaluated recursively)
 *
 * @param values
 * @returns
 */
export function filterEmpty<T>(values: Array<T | undefined | null> | undefined | null): T[] {
	const notBlank = filterBlank(values);
	return notBlank.filter(isNotEmpty);
}
